import { HeroTelemetry } from "@/components/HeroTelemetry";
import { InlineChatLink } from "@/components/InlineChatLink";

const TOPICS = ["AI INFERENCE LOADS", "HYPERSCALER BUILDOUT", "GRID-SCALE POWER", "LIQUID COOLING", "FIBER & INTERCONNECT", "OPERATIONS TALENT", "TECHNICIAN PIPELINE", "SUBSEA & EDGE"];

export default function CommunityPulse() {
  return (
    <section data-testid="community-pulse-section" aria-label="DCYB community" className="bg-white border-b hairline pt-6 md:pt-8" data-chat-safe-area="wide">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <HeroTelemetry />
        <div className="flex justify-center py-2"><InlineChatLink testId="hero-chat-button" visibilityClassName="" /></div>
      </div>
      <div data-testid="hero-industry-marquee" className="border-t hairline bg-[#F7F8F9] overflow-hidden">
        <div className="ticker whitespace-nowrap py-3 flex">
          {[...TOPICS, ...TOPICS].map((topic, index) => (
            <span key={`${topic}-${index}`} data-testid={`hero-industry-topic-${index}`} aria-hidden={index >= TOPICS.length} className="font-mono-label text-[10px] !tracking-normal text-[#5F6168] mx-8 inline-flex items-center gap-3"><span className="w-2 h-px chrome-bar" aria-hidden="true" />{topic}</span>
          ))}
        </div>
      </div>
    </section>
  );
}